interface ISiteMetaValue {
  url: string;
  onboardingUrl: string;
  apiUrl: string;
}

interface ISiteMeta {
  dev: ISiteMetaValue;
  stage: ISiteMetaValue;
  pp: ISiteMetaValue;
  beta: ISiteMetaValue;
  prod: ISiteMetaValue;
}

export const SITE_META: ISiteMeta = {
  dev: {
    url: window.location.origin, // "https://auth.pp.satschel.com",
    onboardingUrl: "https://secure.stage.satschel.com/script.pp.js",
    apiUrl: "https://authentication.stage.satschel.com",
  },
  stage: {
    url: "https://auth.stage.satschel.com",
    onboardingUrl: "https://secure.stage.satschel.com/script.stage.js",
    apiUrl: "https://authentication.stage.satschel.com",
  },
  pp: {
    url: "https://auth.pp.satschel.com",
    onboardingUrl: "https://secure.pp.satschel.com/script.pp.js",
    apiUrl: "https://authentication.pp.satschel.com",
  },
  beta: {
    url: "https://auth.beta.satschel.com",
    onboardingUrl: "https://secure.beta.simplici.io/script.beta.js",
    apiUrl: "https://authentication.beta.satschel.com",
  },
  prod: {
    url: "https://auth.satschel.com",
    onboardingUrl: "https://secure.simplici.io/script.js",
    apiUrl: "https://authentication.satschel.com",
  },
};
